import styles from './index.module.scss';
import SectionPro from '../components/SectionPro';
import EFPicture from '@elem/compCommon/EFPicture';
import EcoProductDetailTop from 'eco-design/sections/eco-product-detail-top';
import FSwiper from '../components/FSwiper';

const EasyUse: React.FC = () => {
    const items = [
        {
            title: '電力消費をリアルタイムモニタリング',
            desc: 'スマホ1つで、いつでもどこでもバッテリー状態や電力使用量を把握。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745030595075/%E3%82%AA%E3%83%95%E3%82%84%E7%B5%A6%E9%9B%BB%E4%B8%AD%E3%81%AE%E6%A9%9F%E5%99%A8%E3%81%BE%E3%81%A6%E3%82%99%E7%B0%A1%E5%8D%98%E5%88%B6%E5%BE%A1.jpg',
            desktop: 'https://websiteoss.ecoflow.com/upload/image/1745030403968/Frame%20128721080%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745908608045/Frame%201612707395%20(2).jpg',
        },
        {
            title: '出力オン/オフや給電中の機器まで簡単制御',
            desc: '出力のオン/オフや接続された電化製品を手元で簡単リモート制御。電力ニーズに応じていつでも・どこでもコントロール可能。',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745030894045/%E9%9B%BB%E5%8A%9B%E6%B6%88%E8%B2%BB%E3%82%92%E3%83%AA%E3%82%A2%E3%83%AB%E3%82%BF%E3%82%A4%E3%83%A0%E3%83%A2%E3%83%8B%E3%82%BF%E3%83%AA%E3%83%B3%E3%82%AF%E3%82%99.jpg',
            desktop: 'https://websiteoss.ecoflow.com/upload/image/1745030404179/Frame%201612707446%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745908341304/Frame%201612707397%20(1).jpg',
        },
    ];
    return (
        <div
            className={`${styles.EasyUse} GtmModuleData-section`}
            id="EasyUse"
            data-section-id={styles.EasyUse}
            data-section-title="スマホアプリで誰でも簡単に使える"
        >
            <SectionPro
                label="出力オン/オフから最新スマート機能まで"
                title={
                    <div>
                        スマホアプリで
                        <br />
                        誰でも簡単に使える
                    </div>
                }
            >
                <div className="list">
                    <FSwiper>
                        {items.map((item) => {
                            return (
                                <div key={item.title} className="item">
                                    <div className="text-box">
                                        <div className="title">{item.title}</div>
                                        <div className="desc">{item.desc}</div>
                                    </div>
                                    <EFPicture className="picture" src={item.pc} srcDesktop={item.desktop} srcMobile={item.h5} />
                                </div>
                            );
                        })}
                    </FSwiper>
                </div>
            </SectionPro>
        </div>
    );
};

export default EasyUse;
